import gql from "graphql-tag";

const gqlQuery = gql`
  query EventEvu($eventId: ID) {
    event(eventId: $eventId) {
      evu
    }
  }
`;

export default eventId => ({
  query: gqlQuery,
  skip: !eventId,
  variables: { eventId },
});
